import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {IPatientPortalActivitiesFilter} from "./patient-portal.model";

@Injectable()
export class PatientPortalActivitiesFilterService{
    public subject: BehaviorSubject<IPatientPortalActivitiesFilter>;

    constructor() {
        this.subject = new BehaviorSubject<IPatientPortalActivitiesFilter>(null)
    }


    public getActivitiesFilter(){
        return this.subject.getValue();
    }

    public setActivitiesFilter(filters : IPatientPortalActivitiesFilter){
        this.subject.next(filters);
    }
}
